module.exports = {"211281001":"兀术街街道","211281002":"调兵山街道","211281102":"晓明镇","211281103":"大明镇","211281105":"晓南镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211281.json
// module id = 540
// module chunks = 0